export const HEADER_STYLES = {
  GREEN: 'green',
  RED: 'red',
};
